import * as Yup from 'yup'
import { passwordSchema } from './password.validation'

const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required('validation-required')
    .min(8, 'validation-password-min')
    .max(250, 'validation-password-max'),
  newPassword: passwordSchema,
  newPasswordConfirm: passwordSchema.oneOf(
    [Yup.ref('newPassword'), null],
    'validation-password-match',
  ),
})

export { changePasswordSchema }
